import React from "react";
import { IMAGES } from "../../lib/constants";

const REGIONS = [
  { code: "BC", name: "British Columbia", cities: "Vancouver · Kelowna · Kamloops" },
  { code: "AB", name: "Alberta", cities: "Calgary · Edmonton · Red Deer" },
  { code: "SK", name: "Saskatchewan", cities: "Regina · Saskatoon" },
  { code: "MB", name: "Manitoba", cities: "Winnipeg · Brandon" },
  { code: "ON", name: "Ontario", cities: "Toronto · Ottawa · Sudbury" },
  { code: "QC", name: "Quebec", cities: "Montréal · Québec · Gatineau" },
  { code: "NB", name: "New Brunswick", cities: "Moncton · Fredericton" },
  { code: "NS", name: "Nova Scotia", cities: "Halifax · Sydney" },
  { code: "PE", name: "Prince Edward Is.", cities: "Charlottetown" },
  { code: "NL", name: "Newfoundland", cities: "St. John's · Corner Brook" },
  { code: "YT", name: "Yukon", cities: "Whitehorse" },
];

export default function Coverage() {
  return (
    <section
      id="coverage"
      className="relative border-b-2 border-[#122A1E] bg-[#122A1E] text-[#F4F4F1]"
      data-testid="coverage-section"
    >
      <img
        src={IMAGES.landscape}
        alt="Canadian wilderness landscape — coast-to-coast vehicle transport coverage"
        loading="lazy"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover opacity-25"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#122A1E]/70 via-[#122A1E]/85 to-[#122A1E]" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid lg:grid-cols-12 gap-8 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="font-mono-accent text-[11px] uppercase text-[#FF5A00] mb-3">
              ◆ 003 · Coverage
            </div>
            <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl md:text-6xl">
              Every Province.
              <br />
              Every Season.
            </h2>
          </div>
          <div className="lg:col-span-5 font-body text-[#F4F4F1]/80 leading-relaxed">
            From Tofino to St. John's, from the 401 to the Yukon — our routes run
            from coast to coast. Remote pickups, island crossings and northern runs to
            Whitehorse available on request.
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-[2px] bg-[#F4F4F1]/20 border-2 border-[#F4F4F1]/20">
          {REGIONS.map((r) => (
            <div
              key={r.code}
              className="bg-[#122A1E] p-5 hover:bg-[#0C1D14] transition-colors"
              data-testid={`coverage-${r.code.toLowerCase()}`}
            >
              <div className="flex items-baseline gap-3 mb-2">
                <span className="font-display font-black text-[#FF5A00] text-3xl leading-none">
                  {r.code}
                </span>
                <span className="font-display font-bold uppercase text-sm text-[#F4F4F1]">
                  {r.name}
                </span>
              </div>
              <div className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/60">
                {r.cities}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-5">
          {[
            { kpi: "11", unit: "Provinces & Territories" },
            { kpi: "7,800+", unit: "KM Longest Route" },
            { kpi: "100%", unit: "Direct Carrier" },
            { kpi: "24 / 7", unit: "Dispatch Tracking" },
          ].map((s, i) => (
            <div key={i} className="border-2 border-[#F4F4F1]/30 p-5">
              <div className="font-display font-black text-3xl md:text-4xl text-[#FF5A00]">
                {s.kpi}
              </div>
              <div className="font-mono-accent text-[10px] uppercase text-[#F4F4F1]/70 mt-1">
                {s.unit}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
